export default "__VITE_ASSET__BpzEeip9__"